
function _uuid() { return crypto.randomUUID(); }

function _elNode(tagName) {
    const id = _uuid();
    return { id, type: 'element', tagName: { value: tagName, version: 0 }, attributes: {}, classes: {}, children: [] };
}

function _addPatch(nodeId, node, parentId, siblingBeforeId) {
    return { type: 'add', clientId: _uuid(), nodeId, seq: 0, parentId: parentId ?? null, siblingBeforeId, node };
}

/**
 * Creates the initial HTML skeleton for a new empty page via REST.
 * Must be called before openPage() so the snapshot is populated when loaded.
 * parentId = null means direct child of the page (server-side root node).
 *
 * @param {string} projectId
 * @param {string} pageId
 * @param {'Document'|'Template'|'Component'} pageType
 */
window.buildPageSkeleton = async function buildPageSkeleton(projectId, pageId, pageType) {
    let patches;

    switch ((pageType ?? '').toLowerCase()) {
        case 'component': {
            const div = _elNode('div');
            patches = [_addPatch(div.id, div, null)];
            break;
        }
        case 'document':
        case 'template':
        default: {
            const html = _elNode('html');
            const head = _elNode('head');
            const body = _elNode('body');
            patches = [
                _addPatch(html.id,  html,  null),        // html is the page root (parentId=null)
                _addPatch(head.id,  head,  html.id),
                _addPatch(body.id,  body,  html.id, head.id),
            ];
        }
    }

    await window.applyPatches(projectId, pageId, patches);
};
